import { useMutation, useQueryClient } from '@tanstack/react-query';
import { makeRequest } from 'features/entry-form-v2/data/makeRequest';
import { useEntries } from 'hooks/store';

export const useAttachCodelistRecordToEntryMutation = (args: {
	originalEntryId: string;
	projectId: string;
	codelistRecordId: string;
}) => {
	const queryClient = useQueryClient();
	const [_, fetchEntries] = useEntries({ lazy: true, filtered: true });

	const invalidateCodelist = () => {
		queryClient.invalidateQueries({
			queryKey: ['codelist', args.originalEntryId, args.projectId]
		});
		queryClient.invalidateQueries({
			queryKey: ['latestDataEntryVersion']
		});
	};

	return useMutation({
		mutationKey: [
			'codelist',
			'attach',
			args.originalEntryId,
			args.projectId,
			args.codelistRecordId
		],
		mutationFn: () =>
			makeRequest({
				method: 'attachCodelistRecordToEntry',
				service: 'cde',
				data: {
					projectId: parseInt(args.projectId),
					entryId: args.originalEntryId,
					codelistRecordId: args.codelistRecordId
				}
			}),
		onSuccess: () => {
			invalidateCodelist();
			fetchEntries();
		},
		retry: false
	});
};
